import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import ZendeskCredentialsStore from '../../../stores/credentials/zendesk-credentials-store';

interface IIntegrationProps {
    credentialsStore: ZendeskCredentialsStore,
    vGroup: IValidationGroup,
}

const ZendeskCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine 
                label='Base API URL'
                note='e.g. https://your-name.zendesk.com'
                required
                key='api_url'
            >
                <Input
                    value={credentialsStore.api_url}
                    placeholder=''
                    onChange={v => credentialsStore.api_url = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine 
                label='Username (your email address)'
                note='e.g. your-zendesk-email@your-email-domain.com'
                required
                key='username'
            >
                <Input
                    value={credentialsStore.username}
                    placeholder=''
                    onChange={v => credentialsStore.username = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine 
                label='Password (API Key)'
                note='As seen at https://your-name.zendesk.com/admin/apps-integrations/apis/zendesk-api/settings'
                required
                key='password'
            >
                <Input
                    value={credentialsStore.password}
                    placeholder=''
                    onChange={v => credentialsStore.password = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default ZendeskCredentials;
